import React, { Fragment, useState, useEffect, useContext } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import FcardBank from "../../components/FcardBank/FcardBank";
import { getBanks, deleteBankbyId } from "../../api/banks";
import Floading from "../../components/Floading/Floading";
import Swal from "sweetalert2";
import { AuthContext } from "../../context/AuthContext";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from 'uuid'
import FBannerTitleButton from "../../components/FspendComponents/FBannerSpend/FBannerTitleButton";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { useHome } from "../Home/hooks/useHome";
import { Trash } from "react-ionicons";
import FContainer from "../../components/FContainer/FContainer";

const CashoutBankAccount = ({ param }) => {
  const route = useNavigate();
  const { state } = useLocation()
  const [arrayBanks, setArrayBanks] = useState([]);
  const { setLoading, setError, checkToken } = useContext(AuthContext);
  const [bankSelected, setBankSelected] = useState(null)
  const [idempotencyKey, setIdempotencyKey] = useState(null)

  const { isRegisteredUser
  } = useHome();

  useEffect(() => {
    _getBanks();
  }, []);

  const {
    processPayment
  } = useProcessor();

  useEffect(() => {
    setIdempotencyKey(uuidv4())
  }, []);

  async function _getBanks() {
    checkToken()
    let _return = false;
    setLoading(true);
    try {
      const dataGetBanks = await getBanks();
      setLoading(false);
      const res = dataGetBanks.data;
      if (res.code == "PROCESS_OK") {
        setArrayBanks(res.data);
      }
    } catch (error) {
      setLoading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        // Swal.fire({
        //   title: "Código incorrecto",
        //   text: "",
        //   imageUrl: require("../../components/assets/images/advertir.png"),
        //   imageWidth: 150,
        //   imageHeight: 150,
        //   confirmButtonColor: "#fd6e0d",
        // });
      }
    }
    return _return;
  }

  const onClickBanks = (data) => {
    nextScreen(data.id, state.transferredAmount)


    // setBankSelected(data)

    // Swal.fire(
    //   {
    //     title:"¿Desea realizar la transferencia?",
    //     text:"Esta acción es irreversible.",
    //     confirmButtonText:'Continuar',
    //     confirmButtonColor:'#fd6e0d',
    //     icon:'warning',
    //     showCloseButton: true,
    //   }
    // ).then((result)=>{
    //   if(result.isConfirmed){
    //     nextScreen(data.id, state.transferredAmount)
    //   }
    // })

  };

  const nextScreen = async (bankId, amount) => {
    if (true == true && idempotencyKey) {
      // const { productId } = route.params;
      const data = {
        originCurrencyId: "484",
        destinationCurrencyId: "484",
        exchangeRateId: null,
        products: [
          {
            id: "CASHOUT_BANK_ACCOUNT_MXN",
            paymentMethod:
            {
              paymentMethodId: bankId
            },
            amount: parseInt(amount)
          },
          {
            id: "FIADO_FUNDS_AVAILABLE_MXN"
          }
        ]
      }
      
      route("/BillScreen2", {
        state: {
          backScreen:"CashoutBank",
          idempotencyKey:idempotencyKey,
          data: data
        },
      });

      //console.log(data)

      // let response = await processPayment(data, idempotencyKey);

      // if (response?.data?.code == "PROCESS_OK") {
      //   //setModalQuestionVisible(false)
      //   const next = () => { }
      //   Swal.fire({
      //     showCloseButton: true,
      //     title: 'Éxito',
      //     text: 'La transferencia se realizó correctamente',
      //     icon: 'success',
      //     showCancelButton: false,
      //     confirmButtonColor: '#fd6e0d',
      //     // iconColor: "#fd6e0d",
      //     confirmButtonText: 'Entendido'
      //   }).then((result) => {
      //     if (result.isConfirmed) {
      //       route("/");
      //     } else {
      //       route("/");
      //     }
      //   })
      // }
      // else if (response?.data?.code == "INVALID_ACCOUNT_NUMBER") {
      //   Swal.fire({
      //     showCloseButton: true,
      //     title: 'Advertencia',
      //     text: 'número de cuenta inválido',
      //     icon: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#fd6e0d',
      //     iconColor: "#fd6e0d",
      //     confirmButtonText: 'Entendido'
      //   })
      //   //setModalQuestionVisible(false)
      // }
      // else if (response?.data?.code == "YOU_REQUEST_CANNOT_BE_PROCESSED_AT_THIS_TIME") {
      //   //setModalQuestionVisible(false)
      //   Swal.fire({
      //     showCloseButton: true,
      //     title: 'Advertencia',
      //     text: 'Su solicitud no puede ser procesada',
      //     icon: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#fd6e0d',
      //     iconColor: "#fd6e0d",
      //     confirmButtonText: 'Entendido'
      //   })
      // } else {
      //   //setModalQuestionVisible(false)
      //   Swal.fire({
      //     showCloseButton: true,
      //     title: 'Advertencia',
      //     text: 'No pudimos procesar tu solicitud en este momento, por favor intenta mas tarde',
      //     icon: 'warning',
      //     showCancelButton: false,
      //     confirmButtonColor: '#fd6e0d',
      //     iconColor: "#fd6e0d",
      //     confirmButtonText: 'Entendido'
      //   })
      // }
    }


  }

  const handleResetBankNumber = (value) => {
    return value.substr(value.length - 4);
  };


  return (
    <>
      <FBannerTitleButton
        title={"Asocia tus cuentas bancarias"}
        titleButton={
          <Fbutton
            value="Agregar banco"
            onClick={() => {
              const requestNavigation = () => {
                route("/CreateBankScreen");
              };

              isRegisteredUser(requestNavigation);
            }}
          />
        }
        imageUrl={require("../../components/assets/images/bank.png")}
      />

      <FContainer>
        {arrayBanks.filter(banck => banck.countryId == "484").map((bank) => (
          <div
            className="border-0 w-full grid grid-cols-12 shadow-Box rounded-2xl px-2 py-3 my-2 cursor-pointer"
            onClick={() => {
              onClickBanks(bank);
            }}
          >
            <div className="border-0 col-span-4 grid place-items-center fix relative">
              <div className="border-0 absolute w-full h-full grid justify-start pl-2">
                {bank.countryId == "840" ? <img className="w-[25px] h-[25px]" src={require("../../components/assets/images/usa.png")} /> : null}
                {bank.countryId == "484" ? <img className="w-[25px] h-[25px]" src={require("../../components/assets/images/MX.png")} /> : null}
              </div>
              <img
                src={require("../../components/assets/images/bank-image.png")}
                className="w-full xxxs:w-[50px] xxs:w-[60px]"
                alt=""
              />
            </div>
            <div className="border-0 col-span-8 grid grid-cols-1 fix relative">
              <div className="border-0 col-span-1 text-center  font-bold text-[3.5vw] smm:text-[14px]">
                <div className="absolute w-full">{bank.countryId != "840" ? bank.bankName : bank.alias}</div>
              </div>
              <div className="border-0 mt-7 col-span-1 text-center font-bold text-Secondary text-[3.5vw] smm:text-[14px]">
                {` **** ${handleResetBankNumber(bank.accountNumber)} `}
              </div>
            </div>
          </div>
        ))}
      </FContainer>

      {/* <FBannerTitleButton
        title={"Asocia tus cuentas bancarias"}
        titleButton={
          <Fbutton
            value="Agregar banco"
            onClick={() => {          
                route("/CreateBankScreen");
            }}
          />
        }
        imageUrl={require("../../components/assets/images/bank.png")}
      />
     


      <div>
        <div className="font-bold text-center p-3">
          ¿En donde te depositamos?
        </div>
        <div className="py-4 border-0 border-dashed p-3 max-h-screen mb-16">
              <FcardBank
                arrayBanks={arrayBanks}
                onClickBanks={onClickBanks}
              />
        </div>
      </div> */}
    </>
  );
};

export default CashoutBankAccount;
